import { BaseButton } from '@/components/Buttons/Core/BaseButton';
import { withStyles } from '@/components/Buttons/Core/withStyles';

export const LinkButton = withStyles(BaseButton, {
    light: 'transparent',
    dark: 'transparent',
    textStyle: {
        light: 'muted.800',
        dark: 'white',
        variant: 'regular'
    }
});